import bseniso17982_4 from './BsEnIso/Config';

export default {
  ...bseniso17982_4,
};
